import { FC } from 'react';
import { CustomSwitch, DisplayText, SubSection, SubSectionContainer } from './all-promotional-sub-section.styles';

interface AllPromotionalSubSectionProps {
  text: string;
  isChecked: boolean;
  onChange: (value: boolean) => void;
}

const AllPromotionalSubSection: FC<AllPromotionalSubSectionProps> = (props) => {
  const { text, isChecked, onChange } = props;

  return (
    <SubSectionContainer>
      <SubSection>
        <DisplayText variant='body2'>
          {text}
        </DisplayText>
        <CustomSwitch
          checked={isChecked}
          onChange={(e, checked) => onChange(checked)}
        />
      </SubSection>
    </SubSectionContainer>
  );
};

export default AllPromotionalSubSection;
